import { graphql } from "@/lib/gql/__generated__";

export const DISCOUNT_ORDINARY_FOR_ORDINARY_CREATE_MUTATION = graphql(/* GraphQL */ `
	mutation discountOrdinaryForOrdinaryCreate($input: DiscountOrdinaryInput!) {
		discountOrdinaryCreate(input: $input) {
			userErrors
		}
	}
`);
